module.exports = __webpack_public_path__ + "img/logo.73fe1e66.svg";